import { Card ,Row,Col, Divider,Button, message,Form,Select, DatePicker, Typography} from "antd";
import React, { Component } from "react";
import Chart from "react-apexcharts";
import { getDashboardBatteryLow, getDashboardBatteryOff } from "../../model/dashboard/requests";
import storage from "../../utils/storage";
import { configs } from "../../config/config";
import { getGroup } from "../../model/group/requests";  
import { BatteryMulOptions,defaultDropShadow,defaultStroke,defaultColors } from "../../model/dashboard/datasource";

const {Option} = Select;
const  {RangePicker} = DatePicker;
const {Title} = Typography
let batteryOptions = BatteryMulOptions

class DashBoardBattery extends Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            options:{},
            customList:[],
            filterDate:[],
            filterCustom:"",
            series: []
          };
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            message.error("token expired")
            this.props.history.push("/")
        }
    }
    componentDidMount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
            return false;
        }

        let data = storage.get(configs.cache.tokenKey)
        
        let group_id = data.group_id
        let series = []
        let _categories = []
        let options = {
            chart: {
                dropShadow: defaultDropShadow,
              },
              stroke: defaultStroke,
              title: {
                text: 'Total',
                 align: 'left'
              },
              colors: defaultColors,
              xaxis:{
                tickPlacement: 'between',
              }
        }
        getDashboardBatteryLow({start:"",end:"",custom_id:""}).then(res=>{
            if (res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data = []
                for (let i=0;i<ret.length;i++){
                    _category.push(ret[i].time)
                    _data.push(ret[i].num)
                }
                let _series_data = {}
                _series_data.data = _data        
                _series_data.name = "Battery low" 
                series.push(_series_data)
                if(_categories.length <= 0 ){
                    _categories.push(..._category)
                }
 
            }
        }).catch(err=>{
            message.error(err)
        })

        getDashboardBatteryOff({start:"",end:"",custom_id:""}).then(res=>{
            if (res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data = []
                for (let i=0;i<ret.length;i++){
                    _category.push(ret[i].time)
                    _data.push(ret[i].num)
                }
          
                
                let _series_data = {}
                _series_data.data = _data        
                _series_data.name = "Battery drain" 

                series.push(_series_data)
                if(_categories.length <= 0 ){
                    _categories.push(..._category)
                }


         }
        }).catch(err=>{
            message.error(err)
        })
     
        // load customList
        let customList = [];
        getGroup({id:group_id}).then(res=>{
            if(res.data.code == 200){
                customList = res.data.data.customs
            }else{
                message.error(res.data.msg)
            }

        }).catch(err=>{
            message.error(err)
        })

        setTimeout(() => {
            options.xaxis.categories = [..._categories]
            this.setState({
                options:options,
                series:series,
                customList:customList
            })
 
          }, 500);
    }

    handlerDateChange = (date,dtString) =>{
        this.setState({
            filterDate:dtString
        })
    }

    handlerCustomChange = (item)=>{
        this.setState({
            filterCustom:item.label
        })
    }

    handlerSearch = ()=>{
        let custom = this.state.filterCustom
        let start = this.state.filterDate.length ==2 ? this.state.filterDate[0] : "";
        let end = this.state.filterDate.length ==2 ? this.state.filterDate[1] : "";
        
        let series = []
        let _categories = []
        let options = {
            chart: {
                dropShadow: defaultDropShadow,
              },
              stroke: defaultStroke,
              title: {
                text: 'Total',
                 align: 'left'
              },
              colors: defaultColors,
              xaxis:{
                tickPlacement: 'between',
              }
        }
        


        getDashboardBatteryLow({start:start,end:end,custom_id:custom}).then(res=>{
           
            if (res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data = []
                for (let i=0;i<ret.length;i++){
                    _category.push(ret[i].time)
                    _data.push(ret[i].num)
                }
                let _series_data = {}
                _series_data.data = _data        
                _series_data.name = "Battery low" 
                series.push(_series_data)
                if(_categories.length <= 0 ){
                    _categories.push(..._category)
                }
            }
        }).catch(err=>{
                message.error(err)
        })  


        getDashboardBatteryOff({start:start,end:end,custom_id:custom}).then(res=>{

            if (res.data.code === 200){
                let ret = res.data.data
                let _category = []
                let _data = []
                for (let i=0;i<ret.length;i++){
                    _category.push(ret[i].time)
                    _data.push(ret[i].num)
                }
                let _series_data = {}
                _series_data.data = _data        
                _series_data.name = "Battery drain" 

                series.push(_series_data)
                if(_categories.length <= 0 ){
                    _categories.push(..._category)
                }
       
            }
        }).catch(err=>{
            message.error(err)
        })


        setTimeout(() => {
            options.xaxis.categories = [..._categories]
            this.setState({
                options:options,
                series:series,
            })
 
          }, 500);

    }
    render(){
        const {options,customList,series} = this.state;
        return(
            <>
                <Title>Dashboard</Title>
                <Divider />
                <Row gutter={[24, 0]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
                        <Card bordered={false} className="criclebox h-full">
                        <Chart
                            options={options}
                            series={series}
                            type="line"
                            height="400px"
                        />
                        </Card>
                    </Col>
                </Row>
            <Divider />
            <Form  name="horizontal_login" layout="inline"  ref={this.formRef} >
                <Form.Item
                    name="date"
                >
                   <RangePicker 
                    onChange={this.handlerDateChange}
                    format="YYYY-MM-DD" />
                </Form.Item>

                    <Form.Item name={'name'}>
                        <Select 
                         placeholder={"Please Chosen a Custom  Id"}
                         onChange={this.handlerCustomChange}
                         labelInValue
                          >
                        {customList.length > 0  && customList.map((items) => {
                                return (<Option key={items.id} value={items.id}>{items.name}</Option>)
                        })}

                        </Select>
                    </Form.Item> 
                    <Form.Item shouldUpdate>
       
                    <Button
                        type="primary"
                        style={{background: "#851dd6" }}
                        onClick={this.handlerSearch}
                    >

                       Filter
                    </Button>
     
                    </Form.Item>
            </Form>  
            
        </>
        )
    }
}

export default DashBoardBattery;